import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { generateVideoUrl as n, parseUrl as r } from "../../helpers/video-url-parser.js";
var i = {
	inline: !1,
	attrs: t({
		type: { default: "video" },
		provider: { default: "youtube" },
		id: { default: "" }
	}),
	group: "block",
	parseDOM: [{
		tag: "iframe",
		getAttrs(e) {
			let { provider: t, id: n } = r(e.src);
			return {
				provider: t,
				id: n
			};
		}
	}],
	toDOM(t) {
		let r = t.attrs, i = n(r.provider, r.id);
		return [
			"div",
			{ class: `${e.blockContainer} ${e.video}` },
			["iframe", {
				src: i,
				style: "pointer-events: none;"
			}]
		];
	}
};
//#endregion
export { i as videoSpec };
